var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { media } from '../../../utilities/media';
const fontSize = (theme, size) => {
    return `${theme.typography.font.sizes[size]}px;`;
};
const MOBILE_FONT_SIZES = ['big', 'medium', 'smedium'];
const DESKTOP_OR_TABLE_FONT_SIZES = ['bigger', 'big', 'medium'];
const MOBILE_LINE_HEIGHT = [1.18, 1.16, 1.33];
const DESKTOP_OR_TABLE_LINE_HEIGHT = [1.16, 1.25, 1.33];
const styles = css `
  strong {
    color: ${({ theme }) => theme.palette.cyan.main};
  }
  // Mobile first
  font-family: ${({ theme }) => theme.typography.font.family.title};
  line-height: ${({ level }) => MOBILE_LINE_HEIGHT[Number(level) - 1]};
  color: ${({ inverted, theme }) => inverted ? theme.palette.white.main : theme.palette.midnight.main};
  font-size: ${({ level, theme }) => fontSize(theme, MOBILE_FONT_SIZES[Number(level) - 1])};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};

  // Table & desktop
  ${media.tablet `
    line-height: ${({ level }) => DESKTOP_OR_TABLE_LINE_HEIGHT[Number(level) - 1]};
    font-size: ${({ level, theme }) => {
    return fontSize(theme, DESKTOP_OR_TABLE_FONT_SIZES[Number(level) - 1]);
}};
  `};
`;
const StyledHeading = styled((_a) => {
    var { level, className, children, inverted } = _a, props = __rest(_a, ["level", "className", "children", "inverted"]);
    return React.createElement(`h${parseInt(level, 10)}`, Object.assign({ className }, props), children);
}) `
  ${styles};
`;
export class Heading extends React.PureComponent {
    render() {
        return React.createElement(StyledHeading, Object.assign({}, this.props));
    }
}
Heading.defaultProps = {
    level: 1,
    inverted: false,
};
//# sourceMappingURL=index.js.map